@if (_active) {
  <kendo-window
    title="{{ _pageState == 5 ? 'ADD NEW RECORD' : _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()" [state]="_windowState" (stateChange)="_onStateChanges($event)" class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4">
    <form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
      <div class="row">
        <div class="col-12">
          <div class="PO-section-header">
            <div class="PO-section-header-title">
              <span>Sales Order</span>
              <span class="statusSection">
                <span class="statusText">Status</span>
                @if ((_model && _model.stockSalesOrderStatusId) ? ((_model.stockSalesOrderStatusId <= 2 || _model.stockSalesOrderStatusId == 6)? true : false) : true) {
                  <span
                    >
                    <input type="radio" formControlName="isClosed" class="is-open" value="false" [disabled]="_pageState == 1" kendoRadioButton />
                    <label class="control-label statusLabel">Open</label>
                    <input type="radio" formControlName="isClosed" class="is-closed" value="true"
                      [disabled]="_pageState == 1" kendoRadioButton />
                      <label class="control-label statusLabel">Closed</label>
                    </span>
                  }
                  @if (_pageState != 2 && _model && _model.stockSalesOrderStatusId) {
                    <label
                    class="control-label statusLabel">{{_currentStatus}}</label>
                  }
                </span>
              </div>
              <div class="header-actions">
                <ul class="menuButtonsList">
                  @if ((_pageState == 2 ||_pageState == 3 ||_pageState == 5) && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                    <li (click)="_onEditForms()"
                      >
                      Edit Forms
                    </li>
                  }
                  @if ((_pageState == 2 ||_pageState == 5 )  && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                    <li class="wikiButton" (click)="_onEditFields()"
                      >
                      Edit Fields
                    </li>
                  }
                  @if (_pageState == 4) {
                    <li (click)="_returnAdNew()">
                      Close Edit Fields
                    </li>
                  }
                  @if (_pageState == 2 ) {
                    <li class="wikiButton" (click)="_viewInactiveFields()">
                      View Inactive Fields
                    </li>
                  }
                </ul>
                @if (isEditMode
                  && stockSalesOrder?.isApprover == true
                  && creator && creator.isCreator == true
                  && creator.isInProgress == true) {
                  <button class="steps_buttons_class" kendoButton
                    (click)="ApproveRejectSalesOrder(true)">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/approve-submit-icon.svg'" />
                    </span>
                    <span>Approve</span>
                  </button>
                }
                @if (isEditMode && stockSalesOrder?.isApprover == true && creator && creator.isCreator == true && creator.isInProgress == true) {
                  <button
                    class="steps_buttons_class" kendoButton (click)="ApproveRejectSalesOrder(false)">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/reject-icon.svg'" />
                    </span>
                    <span>Reject</span>
                  </button>
                }
                @if ((isEditMode && stockSalesOrder?.isCreator == true && creator && creator?.isCreator == true && creator?.isPending == true)) {
                  <button
                    class="steps_buttons_class" kendoButton (click)="OnSubmit()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                    </span>
                    <span>Submit</span>
                  </button>
                }
                @if (_sOtoPOSettings?.enabled && !_isNew && _pageState != 1 && (!(stockSalesOrder ? stockSalesOrder.hasApprovalCycle : hasApprovalCycle) || stockSalesOrder?.isApproved)) {
                  <button class="steps_buttons_class"
                    kendoButton (click)="_showSOToPOWindow()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                    </span>Create PO
                  </button>
                }
                @if (( _pageState != 1)) {
                  <button class="steps_buttons_class" (click)="_onCancel()" kendoButton>
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                    </span>Close
                  </button>
                }
                @if (_pageState != 1 && canAccess('salesOrders', 'create')) {
                  <button class="steps_buttons_class" [disabled]="_pageState == 4 ? true : false" kendoButton
                    (click)="_saveAndCopy()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                    </span>Save & Copy
                  </button>
                }
                @if (_pageState != 1 && canAccess('salesOrders', 'create')) {
                  <button class="steps_buttons_class" [disabled]="_pageState == 4 ? true : false" kendoButton
                    (click)="_saveAndNew()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                    </span>Save & New
                  </button>
                }
                @if (_pageState != 1 && canAccess('salesOrders', 'create')) {
                  <button [disabled]="_pageState == 4 ? true : false" class="steps_buttons_class" kendoButton
                    (click)="_onSave(false,false)">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                    </span>Save & Close
                  </button>
                }
                @if (_isNew && _pageState != 1) {
                  <button class="steps_buttons_class" kendoButton [disabled]="_pageState == 4 ? true : false"
                    (click)="_saveAndPrint()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
                    </span>Save & Print
                  </button>
                }
                @if (_pageState != 1&& canAccess('salesOrders', 'create')) {
                  <button class="steps_buttons_class" kendoButton (click)="_onSave(false,true,'save')"
                    [disabled]="_pageState == 4 ? true : false">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                    </span>Save
                  </button>
                }
                @if (!_isNew && _pageState != 1) {
                  <button class="steps_buttons_class" kendoButton
                    (click)="_showPrintWindow()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
                    </span>Print
                  </button>
                }
                @if (!_isNew && _pageState != 1 && (!(stockSalesOrder ? stockSalesOrder.hasApprovalCycle : hasApprovalCycle) || stockSalesOrder?.isApproved)) {
                  <button class="steps_buttons_class" kendoButton
                    (click)="_showPrintPicklistWindow()">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
                    </span>Print Picklist
                  </button>
                }
              </div>
              @if (_approvalCycleEnabled && _submitted && _isApprovalCycleManager && _pageState != 1) {
                <div class="header-actions"
                  >
                  <button class="steps_buttons_class" kendoButton>
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" />
                    </span>Approve
                  </button>
                  <button class="steps_buttons_class" kendoButton>
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/reject-icon.svg'" />
                    </span>Reject
                  </button>
                  @if (!_isNew) {
                    <button class="steps_buttons_class" kendoButton>
                      <span>
                        <img [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                      </span>Close
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row mt-2 zeromarginRow">
          <div class="col-12">
            <div class="row margin_bottom_15">
              <div class="col-12 col-xl-8 small-pad-right">
                <div class="POWidget info-row">
                  <div class="row">
                    <div class="col-8 p-0">
                      <div class="row">
                        <div class="col-12">
                          <p class="titleStandardStyle">General Information</p>
                        </div>
                        <div class="col-12 margin-top-10">
                          <div class="row">
                            @if (_currentUser && _currentUser.isEnterprise) {
                              <div class="col-12 col-xl-6">
                                <div class="row">
                                  <div class="col-3 pad-right-0">
                                    <label class="control-label">Account</label>
                                  </div>
                                  <div class="col-9 combobox_contaainer">
                                    <accounts-dropdown #kendo_combo_accounts formControlName="account"
                                      [formControl]="_selectedAccount" (accountChanged)="_handleAccountsChange($event)"
                                      class="bordered current-step" [class.active]="_form.get('account').value == null"
                                      [required]="true" [disabled]="_pageState == 1">
                                    </accounts-dropdown>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (_currentUser && _currentUser.isEnterprise) {
                              <div class="col-12 col-xl-6">
                                <div class="row">
                                  <div class="col-3 pad-right-0">
                                    <label class="control-label">Site</label>
                                  </div>
                                  <div class="col-9 combobox_contaainer">
                                    <!-- [disabled]="_form.get('account').value == null" -->
                                    <sites-dropdown #kendo_combo_sites formControlName="site" [placeholder]="'Choose a Site'"
                                      [textField]="'name'" [valueField]="'id'"
                                      [class]="'bordered current-step' + (_form.get('account').value != null && _form.get('site').value == null ? ' active' : '')"
                                      [required]="true" (siteChanged)="_handleSitesChange($event)" [disabled]="_pageState == 1">
                                    </sites-dropdown>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <!--All Sites DropDown-->
                        <sites-dropdown #kendo_combo_SiteCode formControlName="site" [textField]="'code'"
                          [valueField]="'id'" class="bordered" (siteChanged)="_handleSitesChange($event)" [layout]="'row'"
                          [labelText]="'Site Code'" [disabled]="_pageState == 1">
                        </sites-dropdown>
                        <div class="row">
                          <div class="col-12 col-xl-6">
                            <div class="row">
                              <div class="col-3 pad-right-0">
                                <label class="control-label">Customer</label>
                              </div>
                              <div class="col-9 combobox_contaainer">
                                <!-- [disabled]="_form.get('account').value == null || _form.get('site').value == null" -->
                                <kendo-combobox #kendo_combo_customers [data]="_customersFiltered"
                                  [disabled]="_pageState == 1" [filterable]="true"
                                  (valueChange)="_handleCustomersChange($event)"
                                  (filterChange)="_handleCustomersFilter($event)" [suggest]="true"
                                  formControlName="customer" [placeholder]="'Choose a Customer'" [textField]="'code'"
                                  [valueField]="'id'" class="bordered" required>
                                </kendo-combobox>
                                <!-- [class.disabled]="_form.get('account').value == null || _form.get('site').value == null" -->
                                @if (_pageState!=1 && canAccess('customers', 'create')) {
                                  <a class="cursor-pointer" (click)="_openForm('customers')"
                                    >
                                    <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                  </a>
                                }
                                <!-- [class.disabled]="_form.get('account').value == null || _form.get('site').value == null" -->
                                @if (_pageState!=1) {
                                  <a class="cursor-pointer" (click)="_selectCustomersHandler()">
                                    <img class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                  </a>
                                }
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 combobox_contaainer">
                                <textarea #textarea_customeraddress [readonly]="true" class="PO_textarea"
                                [class.customer-textarea]="soPreference?.dispatchTypeEnabled"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-xl-6">
                            @if (soPreference?.dispatchTypeEnabled) {
                              <div class="row">
                                <div class="col-3 pad-right-0">
                                  <label class="control-label">Dispatch Type</label>
                                </div>
                                <div class="col-9 combobox_contaainer d-flex align-items-center">
                                  @for (item of dispatchType; track item) {
                                    <span style="margin-right: 15px; display: inline-flex; align-items: center;">
                                      <input type="radio"
                                        [id]="'dispatch_' + item"
                                        name="dispatchTypeGroup"
                                        [value]="item"
                                        [(ngModel)]="selectedDispatchValue"
                                        [ngModelOptions]="{standalone: true}"
                                        (change)="_handleDispatchChange(item)"
                                        [disabled]="_pageState==1"
                                        kendoRadioButton />
                                        <label [for]="'dispatch_' + item" class="control-label" style="margin-left: 5px; cursor: pointer;">{{ item }}</label>
                                      </span>
                                    }
                                  </div>
                                </div>
                              }
                              <div [class.disabled]="isPickUp" class="row">
                                <div class="col-3 pad-right-0">
                                  <label class="control-label">Ship To</label>
                                </div>
                                <div class="col-9 combobox_contaainer">
                                  <!-- [disabled]="_form.get('account').value == null || _form.get('site').value == null || _form.get('customer').value == null" -->
                                  <kendo-combobox #kendo_combo_addresses [data]="_addressesFiltered" [filterable]="true"
                                    (valueChange)="_handleAddressesChange($event)"
                                    (filterChange)="_handleAddressesFilter($event)" [suggest]="true" formControlName="address"
                                    [textField]="'name'" [valueField]="'id'" [placeholder]="'Choose a Ship To Address'"
                                    [disabled]="_pageState==1">
                                  </kendo-combobox>
                                  <!-- class="bordered" -->
                                </div>
                              </div>
                              <div [class.disabled]="isPickUp" class="row">
                                <div class="col-12 combobox_contaainer">
                                  <textarea #textarea_address [readonly]="true" class="PO_textarea"
                                  [disabled]="_pageState==1"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 p-0 left_border_large">
                        <div class="col-12">
                          <div class="row mx-2">
                            <div class="col-12">
                              <p class="titleStandardStyle"></p>
                            </div>
                            <div class="col-12 margin-top-10">
                              <div class="row">
                                <div class="col-5 col-xl-5 pad-right-0">
                                  <label class="control-label">{{getLabel('LBL_SOOrderDate')?.currentText}}</label>
                                </div>
                                <div class="col-7 col-xl-7 combobox_contaainer_small d-flex">
                                  <kendo-datetimepicker #datetime [min]="_minDate" formControlName="orderDate"
                                    placeholder="Set Date - Time" [format]="_datePickerFormat" [disabled]="_pageState==1 || !getAuthByLabel('LBL_SOOrderDate')?.canEdit">
                                  </kendo-datetimepicker>
                                  <a title="Edit {{getLabel('LBL_SOOrderDate')?.text}}"
                                    [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon d-flex align-items-center"
                                    (click)="_openRenameForm('LBL_SOOrderDate', false, false, false)">
                                    <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 margin-top-5">
                              <div class="row">
                                <div class="col-5 col-xl-5 pad-right-0">
                                  <label class="control-label">Sales Order #</label>
                                </div>
                                <div class="col-7 col-xl-7 combobox_contaainer_small d-flex">
                                  <input #so_input type="text" class="k-textbox writebox min-width-0"
                                    [readonly]="_form.get('account').value == null || _form.get('site').value == null || _form.get('customer').value == null || _pageState==1"
                                    [formControl]="_soNumber" [placeholder]="'Select a Sales Order #'"
                                    (keyup.enter)="_quantitySubmited()" (keydown.Tab)="_quantitySubmited()"
                                    formControlName="soNumber" required />
                                    @if (_pageState!=1) {
                                      <a class="cursor-pointer" (click)="_generateBarcodeClick()">
                                        <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                      </a>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 margin-top-5">
                                <div class="row">
                                  <div class="col-5 col-xl-5 pad-right-0">
                                    <label class="control-label">Due Date</label>
                                  </div>
                                  <div class="col-7 col-xl-7 combobox_contaainer_small">
                                    <kendo-datetimepicker #duedate [min]="_minDate" formControlName="dueDate"
                                      placeholder="Set a Due Date" [format]="_datePickerFormat" [disabled]="_pageState==1">
                                    </kendo-datetimepicker>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 margin-top-5">
                                <div class="row">
                                  <div class="col-5 col-xl-5 pad-right-0">
                                    <label class="control-label">Expected Delivery</label>
                                  </div>
                                  <div class="col-7 col-xl-7 combobox_contaainer_small">
                                    <kendo-datetimepicker #deliverydate [min]="_minDate" formControlName="expectedDeliveryDate"
                                      placeholder="Set a Delivery Date" [format]="_datePickerFormat" [disabled]="_pageState==1">
                                    </kendo-datetimepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-xl-4 small-pad-left">
                    <div class="POWidget info-row">
                      <div class="row">
                        <div class="col-12">
                          <p class="titleStandardStyle">Select or Scan Stock Items#</p>
                        </div>
                        <div class="col-12 display-flex margin-top-10">
                          <div class="row flex-1">
                            <div class="col-4">
                              <label class="control-label">Stock Items #</label>
                            </div>
                            <div class="col-8 combobox_contaainer_small">
                              <!--New Stock Item Drop down-->
                              <kendo-combobox #kendo_combo_items class="bordered current-step newFormControlWidth"
                                [data]="_itemsFilteredNew" [suggest]="true" [filterable]="true" [placeholder]="'Stock Item#'"
                                id="number" name="number" [formControl]="_selectedStockItem" [textField]="'number'"
                                [valueField]="'id'" (valueChange)="_handleItemsChange($event)"
                                (filterChange)="_handleItemsFilterDropDownPaging($event)" (opened)="scrollComboboxNew($event)"
                                [disabled]="_form.get('account').value == null || _form.get('site').value == null || _form.get('soNumber').value == null ||_pageState==1"
                                [attr.disabled]="_form.get('account').value == null || _form.get('site').value == null || _form.get('soNumber').value == null ||_pageState==1"
                                required>
                                <!-- Item Template -->
                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                  <div class="transactions-receive-stock-dropdown-item">
                                    <div class="truncate">{{ dataItem.number }}@if (dataItem.description) {
                                      <span> | {{
                                      dataItem.description }}</span>
                                    }</div>
                                  </div>
                                </ng-template>
                              </kendo-combobox>
                              <!-------------------------------------->
                              <!-- [class.disabled]="_form.get('account').value == null || _form.get('site').value == null || _form.get('customer').value == null || _form.get('soNumber').value == null" -->
                              @if (_pageState!=1) {
                                <span class="asap-input-icon" (click)="_selectStocksHandler()">
                                  <img class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                </span>
                              }
                            </div>
                          </div>
                          <div class="PO-stock-right-checkbox empty"></div>
                        </div>
                        <div class="col-12 display-flex margin-top-5">
                          <div class="row flex-1">
                            <div class="col-4">
                              <label class="control-label">Order Quantity</label>
                            </div>
                            <div class="col-8 combobox_contaainer_small">
                              <kendo-numerictextbox #quantity_input class="k-textbox writebox" [min]="0"
                                [autoCorrect]="autoCorrect" format="{{ quantityFormat }}" [formControl]="_quantity"
                                (keyup.enter)="_quantitySubmited()" (keydown.Tab)="_quantitySubmited()"
                                [disabled]="_pageState==1">
                              </kendo-numerictextbox>
                            </div>
                          </div>
                          <div class="PO-stock-right-checkbox">
                            <input type="checkbox" class="k-checkbox" [formControl]="_defaultQuantity" kendoCheckBox
                              [disabled]="_pageState==1" />
                              <div class="PO-stock-right-checkbox-text">
                                Set as Default
                              </div>
                            </div>
                          </div>
                          <div class="col-12 display-flex margin-top-5">
                            <div class="row flex-1">
                              <div class="col-4">
                                <label class="control-label">Unit Price</label>
                              </div>
                              <div class="col-8 combobox_contaainer_small">
                                <kendo-numerictextbox #unitprice_input class="k-textbox writebox" [min]="0" [autoCorrect]="true"
                                  [formControl]="_unitPrice" (keyup.enter)="_quantitySubmited()" (keydown.Tab)="_quantitySubmited()"
                                  [format]="_costFormat" [disabled]="_pageState==1">
                                </kendo-numerictextbox>
                              </div>
                            </div>
                            <div class="PO-stock-right-checkbox">
                              <input type="checkbox" class="k-checkbox" [formControl]="_defaultUnitPrice" kendoCheckBox
                                [disabled]="_pageState==1" />
                                <div class="PO-stock-right-checkbox-text">Use Default</div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="section-separator"></div>
                            </div>
                            <div class="flex-1">
                <div class="col-12 display-flex" style="
                    margin-left: -15px;">
                                <div class="col-4">
                                  <label class="control-label"> Attached Document </label>
                                </div>
                  <div style="
                    margin-left: -30px;" class="col-8 combobox_contaainer">
                                  <kendo-upload [class.active]="true" style="margin: 0; display: inline-block; width: 255px;"
                                    #kendo_uploader [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" [batch]="false"
                                    [autoUpload]="false" [multiple]="true" class="NextToLabelUpload requiredDropZone"
                                    (select)="_fileSelectedChanges($event)" (remove)="_fileRemoveEventHandler($event)"
                                    [disabled]="_pageState==1">
                                    <kendo-upload-messages [select]="_uploaderSelectMessage" [dropFilesHere]="''">
                                    </kendo-upload-messages>
                                  </kendo-upload>
                                  @if (_pageState != 1) {
                                    <a class="picture-form-external-upload-btn" (click)="_onUploadClick()">
                                      <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                    </a>
                                  }
                                  @if (_pageState != 1) {
                                    <a (click)="_showDocumentsGrid=true" class="asap-input-icon">
                                      <img _ngcontent-sqy-c791="" class="addIcon"
                                        [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                                      </a>
                                    }
                                  </div>
                                </div>
                                <div class="PO-stock-right-checkbox empty"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      @if (stockSalesOrder?.hasApprovalCycle) {
                        <div class="col-12">
                          <div class="POWidget">
                            <div class="row">
                              <div class="col-12">
                                <p class="titleStandardStyle">Sales Order Approval Cycle</p>
                              </div>
                              <div class="col-12">
                                <div class="row">
                                  <div class="col-12 col-lg-8">
                                    <div class="row">
                                      @for (approver of stockSalesOrder?.approvers; track approver) {
                                        <div class="col-3">
                                          <div class="imageAndDescriptionContainer">
                                            @if (approver.isCreator) {
                                              <p class="approvalitems strongGreen">
                                                Creator
                                              </p>
                                            }
                                            @if (approver.isPerson || approver.isManager || approver.isAdmin) {
                                              <p
                                                class="approvalitems strongGreen">
                                                Approver
                                              </p>
                                            }
                                            @if (approver.isCreator || approver.isPerson || approver.isManager) {
                                              <p
                                                class="approvalitems">
                                                {{approver.firstname}} {{approver.lastname}}
                                              </p>
                                            }
                                            @if (approver.isAdmin && !approver.userId) {
                                              <p class="approvalitems">
                                                Admin
                                              </p>
                                            }
                                            @if (approver.isAdmin && approver.userId) {
                                              <p class="approvalitems">
                                                {{approver.firstname}} {{approver.lastname}}
                                              </p>
                                            }
                                            <img class="approvalitems" [src]="'/assets/menu/'+ _theme +'/profile-icon.svg'" />
                                            @if (approver.isInProgress) {
                                              <p class="approvalitems lightGreen">
                                                In progress
                                              </p>
                                            }
                                            @if (approver.isPending) {
                                              <p class="approvalitems lightGreen">
                                                Pending
                                              </p>
                                            }
                                            @if (approver.isAccepted) {
                                              <p class="approvalitems lightGreen">
                                                Accepted
                                              </p>
                                            }
                                            @if (approver.isRejected) {
                                              <p class="approvalitems lightRed">
                                                Rejected
                                              </p>
                                            }
                                            @if (approver.date) {
                                              <p class="approvalitems lightGray">
                                                {{approver.date}}
                                              </p>
                                            }
                                          </div>
                                        </div>
                                        @if (stockSalesOrder?.approvers.indexOf(approver) < stockSalesOrder?.approvers.length - 1) {
                                          <div class="col-1">
                                            <div class="imageAndDescriptionContainer">
                                              <div class="approvalitems">
                                                <img class="arrowPO" [src]="'/assets/menu/'+ _theme +'/arrow-po-icon.svg'" />
                                              </div>
                                            </div>
                                          </div>
                                        }
                                      }
                                      <!-- <div class="col-3">
                                      <div class="imageAndDescriptionContainer">
                                        <p class="approvalitems strongGreen">APPROVER</p>
                                        <p class="approvalitems">GERGES TANNOUS</p>
                                        <img class="approvalitems"
                                          [src]="'/assets/menu/'+ _theme +'/profile-icon.svg'" />
                                          <p class="approvalitems lightGreen">{{ _firstApprovalPending ?
                                            'Pending'
                                          : (_firstApprovalAccepted ? 'Completed' : 'Rejected') }}</p>
                                          <p class="approvalitems lightGray">08/05/2020 15:30PM</p>
                                        </div>
                                      </div>
                                      <div class="col-1">
                                        <div class="imageAndDescriptionContainer">
                                          <div class="approvalitems">
                                            <img class="arrowPO"
                                              [src]="'/assets/menu/'+ _theme +'/arrow-po-icon.svg'" />
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-3">
                                          <div class="imageAndDescriptionContainer">
                                            <p class="approvalitems strongGreen">APPROVER</p>
                                            <p class="approvalitems">hala kmeid</p>
                                            <img class="approvalitems"
                                              [src]="'/assets/menu/'+ _theme +'/profile-icon.svg'" />
                                              <p class="approvalitems lightGreen">{{ _secondApprovalPending ?
                                                'Pending' : (_secondApprovalAccepted ? 'Completed' :
                                                'Rejected')
                                                }}
                                              </p>
                                              <p class="approvalitems lightGray">09/05/2020 15:30PM</p>
                                            </div>
                                          </div> -->
                                        </div>
                                      </div>
                                      <div class="col-12 col-lg-4 left_border_large">
                                        <div class="row">
                                          @if (stockSalesOrder?.isCompletedApprovalCycle) {
                                            <div class="col-3 status-center-style">
                                              <div class="imageAndDescriptionContainer">
                                                <p class="approvalitems strongGreen">status</p>
                                                <img class="approvalitems" [src]="'/assets/menu/'+ _theme +'/complete-po-icon.svg'" />
                                                <p class="approvalitems lightGreen">completed</p>
                                              </div>
                                            </div>
                                          }
                                          @if (stockSalesOrder?.isPendingApprovalCycle) {
                                            <div class="col-3 status-center-style">
                                              <div class="imageAndDescriptionContainer">
                                                <p class="approvalitems strongGreen">status</p>
                                                <img class="approvalitems" [src]="'/assets/menu/'+ _theme +'/pending-po-icon.svg'" />
                                                <p class="approvalitems lightGreen">pending</p>
                                              </div>
                                            </div>
                                          }
                                          @if (stockSalesOrder?.isRejectedApprovalCycle) {
                                            <div class="col-3 status-center-style">
                                              <div class="imageAndDescriptionContainer">
                                                <p class="approvalitems strongGreen">status</p>
                                                <img class="approvalitems" [src]="'/assets/menu/'+ _theme +'/pending-po-icon.svg'" />
                                                <p class="approvalitems lightRed">rejected</p>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="example-wrapper">
                          <div class="row no_row_margin">
                            <div class="col-12 col-lg-9 col-xl-10 responsive_style numericboxtab" #kendo_tabstrip_wrapper
                              [class.ossystem]="_isOs">
                              <kendo-tabstrip (tabSelect)="_onTabSelect($event)" [tabPosition]="_kendoTabStripPosition">
                                @for (tab of _dataTabs; track tab) {
                                  @if (tab.name == 'General') {
                                    <kendo-tabstrip-tab #GeneralTab title="General" [selected]="true">
                                      <ng-template kendoTabContent>
                                        <div class="greytabtop menumobilecontainer">
                                          <img class="mobiletabIcon" (click)="_mobileMenuToggle()"
                                            [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                          </div>
                                          <div class="tabcontent">
                                            <fieldset class="contenttabstyle">
                                              <h2 class="tabcontentTitle">General</h2>
                                              <div class="col-12">
                                                <div class="transactionWidget with-grid numericboxtab">
                                                  <div class="flex-space-between transaction-grid-header-wrapper">
                                                    <p class="titleStandardStyle">
                                                      Selected Items
                                                    </p>
                                                  </div>
                                                  <div style="overflow-x: scroll !important">
                                                    <kendo-grid [data]="_inventoryGridData" [scrollable]="'none'" class="PO-grid"
                                                      (remove)="_removeHandler($event)">
                                                      @if (false) {
                                                        <kendo-grid-column field="id">
                                                        </kendo-grid-column>
                                                      }
                                                      <kendo-grid-column field="itemNumber" title="Stock Item #">
                                                      </kendo-grid-column>
                                                      <kendo-grid-column field="description" title="Stock Description">
                                                      </kendo-grid-column>
                                                      <kendo-grid-column field="unitsOrdered" title="Order Quantity">
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                          <kendo-numerictextbox class="PO-grid-quantity" [value]="dataItem.unitsOrdered"
                                                            format="{{ quantityFormat }}"
                                                            (valueChange)="_onOrderQuantityChange($event, dataItem)" [min]="0"
                                                            [autoCorrect]="true" [disabled]="_pageState==1">
                                                          </kendo-numerictextbox>
                                                        </ng-template>
                                                      </kendo-grid-column>
                                                      <kendo-grid-column field="uom" title="UOM Code">
                                                      </kendo-grid-column>
                                                      <kendo-grid-column field="unitPrice" title="Unit Price">
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                          <kendo-numerictextbox class="PO-grid-quantity" [value]="dataItem.unitPrice"
                                                            (valueChange)="_onUnitPriceChange($event, dataItem)" [min]="0"
                                                            [format]="_costFormat" [autoCorrect]="true" [disabled]="_pageState==1">
                                                          </kendo-numerictextbox>
                                                        </ng-template>
                                                      </kendo-grid-column>
                                                      <kendo-grid-column field="extendedPrice" title="Extended Price">
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                          <kendo-numerictextbox class="PO-grid-quantity" [value]="dataItem.extendedPrice"
                                                            [min]="0" [disabled]="true" [format]="_costFormat">
                                                          </kendo-numerictextbox>
                                                        </ng-template>
                                                      </kendo-grid-column>
                                                      <kendo-grid-checkbox-column field="isTaxable" title="Taxable">
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                          <input type="checkbox" class="k-checkbox" kendoCheckBox
                                                            [checked]="dataItem.isTaxable" [disabled]="_pageState==1" />
                                                          </ng-template>
                                                        </kendo-grid-checkbox-column>
                                                        <kendo-grid-column field="unitsIssued" title="Issued Qty">
                                                          <ng-template kendoGridCellTemplate let-dataItem>
                                                            <kendo-numerictextbox class="PO-grid-quantity" [value]="dataItem.unitsIssued"
                                                              format="{{ quantityFormat }}" [min]="0" [disabled]="true">
                                                            </kendo-numerictextbox>
                                                          </ng-template>
                                                        </kendo-grid-column>
                                                        <kendo-grid-column field="backorderQty" title="Backorder Qty">
                                                          <ng-template kendoGridCellTemplate let-dataItem>
                                                            <kendo-numerictextbox class="PO-grid-quantity" [value]="dataItem.backorderQty"
                                                              format="{{ quantityFormat }}" [min]="0" [disabled]="true">
                                                            </kendo-numerictextbox>
                                                          </ng-template>
                                                        </kendo-grid-column>
                                                        @if (_pageState!=1) {
                                                          <kendo-grid-command-column title="Action">
                                                            <ng-template kendoGridCellTemplate>
                                                              <div kendoGridRemoveCommand class="asap-grid-remove">
                                                                <div class="asap-grid-remove-icon">
                                                                  <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                                </div>
                                                                <div class="asap-grid-remove-text">
                                                                  Delete
                                                                </div>
                                                              </div>
                                                            </ng-template>
                                                          </kendo-grid-command-column>
                                                        }
                                                      </kendo-grid>
                                                    </div>
                                                    <div class="kendoGridCustomFooter">
                                                      <ul class="kendoGridCustomFooterContent">
                                                        <li class="totalTitle">
                                                          subtotal<span [innerHTML]="_subtotal  | costFormat"></span>
                                                        </li>
                                                        <li class="doubleWidth doubleWidthNoWrap">
                                                          <label class="control-label">Shipping</label>
                                                          <kendo-numerictextbox [value]="_shipping" (valueChange)="_onShippingChange($event)"
                                                            [min]="0" [format]="_costFormat" [autoCorrect]="true" [disabled]="_pageState==1">
                                                          </kendo-numerictextbox>
                                                        </li>
                                                        <li class="doubleWidth doubleWidthNoWrap">
                                                          <label class="control-label">Discount</label>
                                                          <kendo-numerictextbox [value]="_discount" (valueChange)="_onDiscountChange($event)"
                                                            [min]="0" [format]="_costFormat" [autoCorrect]="true" [disabled]="_pageState==1">
                                                          </kendo-numerictextbox>
                                                        </li>
                                                        <li class="doubleWidth">
                                                          <label class="control-label">Other Adjustments</label>
                                                          <kendo-numerictextbox class="otherAdjustmentNb" [value]="_otherAdjustment"
                                                            [disabled]="_pageState==1" (valueChange)="_onOtherAdjustmentChange($event)"
                                                            [min]="0" [format]="_costFormat" [autoCorrect]="true" style="display: contents;">
                                                          </kendo-numerictextbox>
                                                        </li>
                                                        <li class="doubleWidth doubleWidthNoWrap">
                                                          <label class="control-label">Tax</label>
                                                          <kendo-numerictextbox [value]="_tax" (valueChange)="_onTaxChange($event)" [min]="0"
                                                            [format]="_costFormat" [autoCorrect]="true" [disabled]="_pageState==1">
                                                          </kendo-numerictextbox>
                                                        </li>
                                                        <li class="totalTitle">
                                                          total<span [innerHTML]="_total  | costFormat"></span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                                <asap-custom-fields-form [customFields]="_customFields[tab.id]" [pageState]="_pageState"
                                                  [accounts]="_selectedAccountIds" [formName]="'stock'" page="salesOrders"
                                                  [invalidSubmit]="_invalidSubmit"
                                                  (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                  (customFieldsDeleteValue)="_removeCustomField($event)"
                                                  (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                  (customFieldsStatus)="formStatus($event)" [_customFieldsValue]="_customFieldsValue">
                                                </asap-custom-fields-form>
                                                @if (_pageState != 1) {
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                                      <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New
                                                    Field</span>
                                                  </button>
                                                </div>
                                              }
                                            </fieldset>
                                          </div>
                                        </ng-template>
                                      </kendo-tabstrip-tab>
                                    }
                                    <!-- Documents Tab -->
                                    @if (tab.name == 'Documents') {
                                      <kendo-tabstrip-tab [title]="tab.name">
                                        <ng-template kendoTabContent>
                                          <div class="greytabtop menumobilecontainer">
                                            <img class="mobiletabIcon" (click)="_mobileMenuToggle()"
                                              [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                            </div>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle">
                                                <h2 class="tabcontentTitle">Documents</h2>
                                                <!-- Tab Static Content -->
                                                <div class="greytabtop">
                                                  <button [class.ViewModeHiddenElement]="_pageState == 1" kendoButton
                                                    (click)="_openForm(_documentsPageName)" class="topRightButtonSecond">
                                                    Add Documents
                                                  </button>
                                                  <button [class.ViewModeHiddenElement]="_pageState == 1" kendoButton
                                                    (click)="_selectDocumentsHandler($event)" class="topRightButton">
                                                    Select from Library
                                                  </button>
                                                </div>
                                                <div class="tabcontent tabWizGridInside" [class.ViewModeDisabledControl]="_pageState == 1">
                                                  <!-- [selectable]="true" -->
                                                  <asap-grid-layout [returnedSelectedKeys]="_selectedDocumentsKeys" [pagingEnabled]="false"
                                                    [enableSiteSelection]="false" [data]="_purchaseOrderFilesDoc" [isData]="true"
                                                    (doubleClickEvent)="_doDownloadFile($event)" class="gridWithcontent">
                                                    <ng-template pageListColumn name="Name" field="file.name" let-item>
                                                      {{item.file.name}}
                                                    </ng-template>
                                                    <ng-template pageListColumn name="Description" field="file.description" let-item>
                                                      {{item.file.description}}
                                                    </ng-template>
                                                    <ng-template pageListColumn name="Type" field="file.type" let-item>
                                                      {{item.file.type}}
                                                    </ng-template>
                                                    <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                                                      <div class="asap-grid-remove" (click)="_removeDocHandler(item)">
                                                        <div class="asap-grid-remove-icon">
                                                          <img src="/assets/menu/enterprise/remove-icon.svg" />
                                                        </div>
                                                        <div class="asap-grid-remove-text">Delete</div>
                                                      </div>
                                                    </ng-template>
                                                  </asap-grid-layout>
                                                </div>
                                                <!-- Tab Custom Fields -->
                                                <div class="tabcontent p-0">
                                                  <fieldset class="contenttabstyle margin-top-10">
                                                    <asap-custom-fields-form [customFields]="_customFields[tab.id]" [pageState]="_pageState"
                                                      [accounts]="_selectedAccountIds" [formName]="'asset'" [page]="_page"
                                                      [invalidSubmit]="_invalidSubmit"
                                                      (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                      (customFieldsDeleteValue)="_removeCustomField($event)"
                                                      (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                      (customFieldsStatus)="formStatus($event)" [_customFieldsValue]="_customFieldsValue">
                                                    </asap-custom-fields-form>
                                                  </fieldset>
                                                </div>
                                                <div class="form-group special_style_formgroup">
                                                  <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                                    <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New
                                                  Field</span>
                                                </button>
                                              </div>
                                            </fieldset>
                                          </div>
                                        </ng-template>
                                      </kendo-tabstrip-tab>
                                    }
                                    @if (tab.isCustom) {
                                      <kendo-tabstrip-tab [title]="tab.name">
                                        <ng-template kendoTabContent>
                                          <div class="tabcontent">
                                            <fieldset class="contenttabstyle margin-top-10">
                                              <asap-custom-fields-form [customFields]="_customFields[tab.id]" [pageState]="_pageState"
                                                [accounts]="_selectedAccountIds" [formName]="'stock'" page="salesOrders"
                                                [invalidSubmit]="_invalidSubmit"
                                                (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                (customFieldsDeleteValue)="_removeCustomField($event)"
                                                (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                (customFieldsStatus)="formStatus($event)" [_customFieldsValue]="_customFieldsValue">
                                              </asap-custom-fields-form>
                                              <div class="form-group special_style_formgroup">
                                                <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                                  <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New
                                                Field</span>
                                              </button>
                                            </div>
                                            <div class="form-group special_style_formgroup">
                                              <button kendobutton class="addNewFieldButton k-button"
                                                (click)="_deactivateTab(tab.id, 'pickList')">
                                                <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate
                                              Tab</span>
                                            </button>
                                          </div>
                                        </fieldset>
                                      </div>
                                    </ng-template>
                                  </kendo-tabstrip-tab>
                                }
                              }
                            </kendo-tabstrip>
                          </div>
                          <div class="col-12 col-lg-3 col-xl-2 responsive_style">
                            <div class="borderedNotesContainer">
                              <note #note [_pageState]="_pageState" [_model]="_model" [_page]="_page"></note>
                            </div>
                          </div>
                        </div>
                        @if (_pageState != 1) {
                          <div class="row no_row_margin">
                            <div class="col-12">
                              <button kendobutton class="addNewtabButton k-button" (click)="_addNewTab()">
                                <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                              </button>
                            </div>
                          </div>
                        }
                        @if (_pageState != 1) {
                          <div class="row no_row_margin">
                            <div class="col-12">
                              <button kendobutton class="reorderTabButton k-button" (click)="_reorderingtabs()">
                                <img class="backimage" src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    @if (_showStocksGrid) {
                      <kendo-window title="{{'ADD STOCK ITEM TO SALES ORDER'}}" (close)="_closeStocksWindow()"
                        class="addFromLibrary">
                        <div class="greytabtop">
                          <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedStocksHandler($event)">
                            Select & Return
                          </button>
                        </div>
                        @if (_stockItemsGridColumns) {
                          <asap-grid-layout [page]="'stockItems'" [entityName]="'stock'"
                            [sortingEnabled]="true" [enableSiteSelection]="false" [resolver]="_getStockItems" [orderEnable]="true"
                            class="ListGrid" [selectable]="true" [pagingEnabled]="true" [selectByField]="_selectedCallback"
                            [filteringEnable]="true" [addNewFormEnabled]="false" [deletedEnabled]="false" [DisableDestory]="false"
                            [headerEnable]="true" [enableSiteSelection]="false"
                            (onRowSelectionChanges)="_onStockRowSelectionChanges($event)">
                            @for (column of _stockItemsGridColumns; track column) {
                              @if (column.selected) {
                                @if (column.isTemplate) {
                                  <ng-template pageListColumn [field]="column.field"
                                    [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                    let-item>
                                    @if (column?.type == 'date') {
                                      {{ item[column.field] | dateFormat }}
                                    }
                                    <!-- <ng-container
                    *ngIf="(column?.type != 'date' || column.type==null )
                && column.formatType != quantityFormatType && column.formatType != costPriceFormatType ">&& column.field != 'quantityPerAccount'
                                    {{item[column.field]}}
                                    {{getFieldValue(item,column.field)}}
                                    {{column.field | complexFieldValue: item}}
                                  </ng-container> -->
                                  @if (column.isCustomField == true) {
                                    {{item[column.field]}}
                                  }
                                  @if (column.field == 'stockItemSites.account.name') {
                                    {{getAccountNames(item.stockItemSites)}}
                                  }
                                  @if (column.formatType == costPriceFormatType) {
                                    {{column.field | complexFieldValue: item | costFormat}}
                                  }
                                  @if (column.formatType == quantityFormatType ) {
                                    {{column.field | complexFieldValue: item | quantityFormat}}
                                  }
                                  @if (column.field =='site.code' || column.field == 'site.name') {
                                    {{item.site == null ? 'All Sites' : column.field | complexFieldValue: item}}
                                  }
                                </ng-template>
                              }
                              @if (!column.isTemplate ) {
                                <!--&& _currentUser.isEnterprise == false  && column.field != 'quantityPerAccount' -->
                                <ng-template pageListColumn [field]="column.field"
                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                  let-item>
                                  @if (column.field == 'markupType') {
                                    {{ getMarkupType(item,column.field) }}
                                  }
                                  @if (column.type == 'date' && column.isCustomField == false) {
                                    {{ item[column?.field] | dateFormat }}
                                  }
                                  @if (column.type != 'date' && column.type != 'image' && column.isCustomField == false
                                    && column.formatType != quantityFormatType && column.formatType != costPriceFormatType) {
                                    @if (column.field == 'notes') {
                                      <a style="cursor: pointer;"
                                        (click)="_showStockItemNotesWindow(item.id)">
                                        <img class="notesIcon" [src]="'/assets/menu/'+ _theme +'/note-icon.svg'" />
                                      </a>
                                    }
                                    @if (column.field != 'notes') {
                                      <label>
                                        {{column.field | complexFieldValue: item}}
                                      </label>
                                    }
                                  }
                                  <!-- <ng-container
                                  *ngIf="(column.type != 'date'  || column.type==null )&& column.field != 'category.categoryFiles.file.thumbnail'&&column.field != 'stockItemFiles.file.thumbnail'"><!-- && column.field != 'quantityPerAccount'
                                  {{column.field | complexFieldValue: item}}
                                </ng-container> -->
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                                @if (column.field == 'category.categoryFiles.file.thumbnail' && column.type == 'image') {
                                  @if (item.category.categoryFiles != undefined) {
                                    <div class="Category-icon">
                                      <img [src]="displayCatImage(column.field | complexFieldValue: item,item.category.categoryFiles)"
                                        appImagePopup width="100" />
                                      </div>
                                    }
                                  }
                                  @if (column.field == 'stockItemFiles.file.thumbnail' && column.type == 'image') {
                                    @if (item.stockItemFiles != undefined) {
                                      <div class="Category-icon">
                                        <img [src]="displayStockImage(column.field | complexFieldValue: item,item.stockItemFiles)"
                                          width="100" appImagePopup />
                                          <!-- (click)="openStockImagePopup(item.stockItemFiles)" -->
                                        </div>
                                      }
                                    }
                                  </ng-template>
                                }
                              }
                            }
                            <!-- <ng-container *ngFor="let column of _stockItemsGridColumns">
                            <ng-container *ngIf="column.selected">
                              <ng-container *ngIf="column.isTemplate">
                                <ng-template
                                  pageListColumn
                                  [field]="column.field"
                                  [name]="column.title"
                                  [type]="column.type"
                                  let-item
                                  >
                                  <ng-container
                                    *ngIf="column.field == 'inventoryUnitOfMeasure.code'"
                                    >
                                    {{item.inventoryUnitOfMeasure?.code}}
                                  </ng-container>
                                  <ng-container
                                    *ngIf="column.field == 'inventoryUnitOfMeasure.unitName'"
                                    >
                                    {{item.inventoryUnitOfMeasure?.unitName}}
                                  </ng-container>
                                  <ng-container
                                    *ngIf="column.field == 'receiveUnitOfMeasure.code'"
                                    >
                                    {{item.receiveUnitOfMeasure?.code}}
                                  </ng-container>
                                  <ng-container
                                    *ngIf="column.field == 'receiveUnitOfMeasure.unitName'"
                                    >
                                    {{item.receiveUnitOfMeasure?.unitName}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'issueUnitOfMeasure.code'">
                                    {{item.issueUnitOfMeasure?.code}}
                                  </ng-container>
                                  <ng-container
                                    *ngIf="column.field == 'issueUnitOfMeasure.unitName'"
                                    >
                                    {{item.issueUnitOfMeasure?.unitName}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'itemType.name'">
                                    {{item.itemType?.name}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'category.id'">
                                    {{item.category?.id}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'category.description'">
                                    {{item.category?.description}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'costType.code'">
                                    {{item.costType?.code}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'costInfo.cost'">
                                    {{item.costInfo?.cost}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'costInfo.markupPercent'">
                                    {{item.costInfo?.markupPercent}}
                                  </ng-container>
                                  <ng-container *ngIf="column.field == 'costInfo.markupNumber'">
                                    {{item.costInfo?.markupNumber}}
                                  </ng-container>
                                </ng-template>
                              </ng-container>
                              <ng-container *ngIf="!column.isTemplate">
                                <ng-template
                                  pageListColumn
                                  [field]="column.field"
                                  [name]="column.title"
                                  [type]="column.type"
                                  let-item
                                  >
                                  <ng-container *ngIf="column.type == 'date'">
                                    {{ item[column.field] | dateFormat}}
                                  </ng-container>
                                  <ng-container *ngIf="column.type != 'date'">
                                    {{item[column.field]}}
                                  </ng-container>
                                </ng-template>
                              </ng-container>
                            </ng-container>
                          </ng-container> -->
                        </asap-grid-layout>
                      }
                    </kendo-window>
                  }
                  @if (_showCustomersGrid) {
                    <kendo-window title="{{'Select Customer'}}" (close)="_closeCustomersWindow()"
                      class="addFromLibrary">
                      <div class="greytabtop">
                        <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedCustomerHandler($event)">
                          Select & Return
                        </button>
                      </div>
                      @if (_customersGridColumns) {
                        <asap-grid-layout [page]="'customers'" [entityName]="'customer'"
                          [sortingEnabled]="true" [enableSiteSelection]="false" [resolver]="_getCustomers" [orderEnable]="true"
                          class="ListGrid" [selectable]="true" [singleSelect]="true" [pagingEnabled]="true"
                          [selectByField]="_selectedCallback" [filteringEnable]="true" [addNewFormEnabled]="false"
                          [deletedEnabled]="false" [DisableDestory]="false" [headerEnable]="true" [groupingEnabled]="true"
                          [enableSiteSelection]="false" (onRowSelectionChanges)="_onCustomerRowSelectionChanges($event)">
                          @for (column of _customersGridColumns; track column) {
                            @if (column.selected) {
                              @if (!column.isTemplate) {
                                <ng-template pageListColumn [field]="column.field"
                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                  let-item>
                                  @if (column.type == 'date' && column.isCustomField == false) {
                                    {{ (column.field | complexFieldValue: item) | dateFormat }}
                                  }
                                  @if (column.type != 'date' && column.isCustomField == false) {
                                    @if (column.field == 'notes') {
                                      <a style="cursor: pointer;"
                                        (click)="_showCustomerNotesWindow(item.id)">
                                        <img class="notesIcon" [src]="'/assets/menu/'+ _theme +'/note-icon.svg'" />
                                      </a>
                                    }
                                    @if (column.field != 'notes') {
                                      <label>
                                        {{column.field | complexFieldValue: item}}
                                        ta
                                      </label>
                                    }
                                    ta
                                  }
                                  <!-- <ng-container *ngIf="column.type != 'date' && column.isCustomField == false">
                                  {{column.field | complexFieldValue: item}}
                                </ng-container> -->
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                              </ng-template>
                            }
                            @if (column.isTemplate) {
                              <ng-template pageListColumn [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title" [type]="column.type"
                                let-item>
                                @if (column.type == 'date' && column.isCustomField == false) {
                                  {{ (column.field | complexFieldValue: item) | dateFormat }}
                                }
                                @if (column.type != 'date' && column.isCustomField == false
                                  ) {
                                  {{column.field | complexFieldValue: item}}
                                }
                                @if (column.isCustomField == true) {
                                  {{item[column.field]}}
                                }
                                @if (column.field == 'site.code' && !item.site) {
                                  All Sites
                                }
                                @if (column.field == 'site.name' && !item.site) {
                                  All Sites
                                }
                              </ng-template>
                            }
                          }
                        }
                      </asap-grid-layout>
                    }
                  </kendo-window>
                }
                @if (_showAddCustomerWindow) {
                  <div kendoWindowContainer></div>
                }
                <div class="row">
                  <div class="col-12">
                    @if (_invalidForm) {
                      <asap-forms-validation-summary [form]="_form" [page]="_page"
                        [customValidation]="_customValidation" [additionalErrors]="_additionalErrors">
                      </asap-forms-validation-summary>
                    }
                  </div>
                </div>
                @if (_isDialiog) {
                  <asap-dialog-layout [componentName]="_dialogComponentName" [data]="_dialogModel"
                    (closeDialog)="_closeDialog($event)">
                  </asap-dialog-layout>
                }
              </form>
              @if (_deactivatedFieldsForm) {
                <kendo-window title="Deactivated Fields" (close)="_closeInactiveFields()">
                  <div class="row no_row_margin margin-top-30">
                    <div class="col-12 margin-top-10">
                      <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                        <kendo-grid-column field="name" title="Fields Name">
                        </kendo-grid-column>
                        <kendo-grid-column field="formTab.name" title="Tab Name">
                        </kendo-grid-column>
                        <kendo-grid-column field="createdOn" title="Added Date" type="date">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.createdOn | dateFormat}}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="lastUpdatedOn" title="Deactivation Date" type="date">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.lastUpdatedOn | dateFormat}}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="Command" title="Command">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <div class="action-button action-button-deactivate" (click)="_reactivate(dataItem)">
                              <div class="action-button-icon">
                                <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                              </div>
                              <div class="edit-icon-text">Reactivate</div>
                            </div>
                          </ng-template>
                        </kendo-grid-column>
                      </kendo-grid>
                    </div>
                  </div>
                </kendo-window>
              }
              @if (_showStocksGrid || _showCustomersGrid || _deactivatedFieldsForm || showReports || showSOToPOWindow || _editFormActive
                || _orderingTabsForm || _showDocumentsGrid) {
                <div class="k-overlay"></div>
              }
              @if (_pageState == 3) {
                <div class="asap-footer">
                  <ul class="asap-footer-content-list">
                    <li>
                      <span class="label-footer">Date Added:</span>{{
                      _model.createdOn |
                      dateFormat
                      }}<span class="separator">.</span><span class="label-footer">Added By User:</span>{{
                      _model.createdBy?
                      _model.createdBy.userName : null
                      }}
                    </li>
                    <li>
                      <span class="label-footer">Last Edited:</span>
                      {{ _model.lastUpdatedOn | dateFormat }}
                      <span class="separator">.</span>
                      <span class="label-footer">Last Edited By User:</span>
                      {{_model.lastUpdatedBy? _model.lastUpdatedBy.userName : null}}
                    </li>
                  </ul>
                </div>
              }
            </kendo-window>
          }
          @if (showReports) {
            <kendo-window [width]="750" (close)="_closePrint()" (keydown.enter)="$event.preventDefault()"
              style="z-index:100005">
              <div class="col-12 form-group">
                <div style="margin-top: 10px;  margin-right: 5px;">
                  <button (click)="_closePrint()" kendoButton class="steps_buttons_class">
                    <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                    <span>close</span>
                  </button>
                  <button (click)="_printReceiptReport()" kendoButton class="steps_buttons_class">
                    <span><img class="backimage" [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span>Print
                  </button>
                </div>
                <label class="control-label trl" style="margin-top: 15px;">Sales Order Receipt</label>
                <kendo-combobox #kendo_combo_Receipt_Report [data]="salesOrderReports" [suggest]="true"
                  class="bordered reportCombobox" [textField]="'name'" [valueField]="'id'"
                  placeholder="Select Sales Order Print Receipt">
                </kendo-combobox>
              </div>
              <!-- <button
              class="noborder_left hidden-xs"
              kendoButton
              (click)="_printReceiptReport()"
              >
              <div style="margin-left: 20px;">
                <span><img [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" /></span
                  ><span style="font-size: 13px;" >Print</span>
                </div>
              </button> -->
            </kendo-window>
          }

          @if (showSOToPOWindow) {
            <kendo-window title="ADD NEW PO" class="fullWidthFormForm" (close)="_closeSOToPOForm()"
              (keydown.tab)="$event.preventDefault()">
              <div class="col-12 zeroPaddingColumn">
                <form (keydown.enter)="$event.preventDefault()" class="form_style">
                  <div class="row zeromarginRow">
                    <div class="col-12">
                      <div class="header-actions" style="margin-top: 15px; text-align: end">
                        <!-- <button
                        class="steps_buttons_class"
                        kendoButton
                        (click)="_potoSOProcess()"
                        >
                        <span
                          ><img
                          [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" /></span
                          >Process
                        </button> -->
                        <div class="row no_row_margin">
                          <div class="col-12">
                            <button class="steps_buttons_class" kendoButton (click)="_closeSOToPOForm()">
                              <span>
                                <img [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                              </span>Close
                            </button>
                            <button kendoButton class="steps_buttons_class" (click)="_potoSOProcess()">
                              <!-- <img
                              class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'"
                              />
                              <span>Process</span> -->
                              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>Save & Close</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="asap-section-container">
                        <div class="row zeromarginRow">
                          <div class="col-12 col-lg-8 zeroPaddingColumn">
                            <div class="row">
                              <div class="col-12">
                                <p class="titleStandardStyle">
                                  Do you want to use the same "Order"?
                                </p>
                              </div>
                              <div class="col-12">
                                <div class="form-group special_style_formgroup">
                                  <div class="row">
                                    <!-- <div class="col-2">
                                    <label class="control-label">Same Order</label>
                                  </div> -->
                                  <div class="col-9 d-flex align-items-center">
                                    @for (item of _soToPOOrderData; track item) {
                                      <span style="margin-right: 20px; display: inline-flex; align-items: center;">
                                        <input type="radio"
                                          [id]="'soOrder_' + item.id"
                                          name="soOrderOption"
                                          [value]="item"
                                          [checked]="_selectedSOtoPOOrderOption?.value?.value === item.value"
                                          (change)="_selectedSOtoPOOrderOption.setValue(item); _SOrderValueChanged(item)"
                                          kendoRadioButton />
                                          <label [for]="'soOrder_' + item.id" class="control-label" style="margin-left: 5px; cursor: pointer;">{{ item.name }}</label>
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <p class="titleStandardStyle">
                                  Do you want to use the same "Vendor"?
                                </p>
                              </div>
                              <div class="col-12">
                                <div class="form-group special_style_formgroup">
                                  <div class="row">
                                    <!-- <div class="col-2">
                                    <label class="control-label">Supplier Status</label>
                                  </div> -->
                                  <div class="col-9 d-flex align-items-center">
                                    @for (item of _soToPOVendorData; track item) {
                                      <span style="margin-right: 20px; display: inline-flex; align-items: center;">
                                        <input type="radio"
                                          [id]="'soVendor_' + item.id"
                                          name="soVendorOption"
                                          [value]="item"
                                          [checked]="_selectedSOtoPOVendorOption?.value?.value === item.value"
                                          (change)="_selectedSOtoPOVendorOption.setValue(item); _SStatusValueChanged(item)"
                                          [disabled]="_isStatusDisabled"
                                          kendoRadioButton />
                                          <label [for]="'soVendor_' + item.id" class="control-label" style="margin-left: 5px; cursor: pointer;">{{ item.name }}</label>
                                        </span>
                                      }
                                      <span class="comboboxSkipButton" (click)="_skipSStatus()" style="margin-left: 10px;">
                                        skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="asap-section-container with-grid" [class.active]="_addClassActive">
                        <div class="row zeromarginRow">
                          <div class="col-12">
                            <p class="titleStandardStyle margin-top-10">
                              <span>Selected Items</span>
                              <span class="autoGenerateSection">
                                <span>
                                  <input type="checkbox" kendoCheckBox (input)="_onautoGenerateChange($event)" />
                                  <label class="control-label autoGenerateLabel">Auto-Generate PO#</label>
                                </span>
                              </span>
                            </p>
                          </div>
                        </div>
                        <kendo-grid [data]="_SOtoPOGridData" [scrollable]="'none'" class="asap-standalone-grid"
                          (remove)="_removePoGrid($event)">
                          <!-- <kendo-grid-column field="PONumber" title="PO#">
                          <ng-template
                            kendoGridCellTemplate
                            let-dataItem
                            let-rowIndex="rowIndex"
                            >
                            <kendo-textbox
                              (valueChange)="_poNumberValueChange($event, rowIndex)"
                              value="{{dataItem.PONumber}}"
                              class="k-input writebox smallNumeric requirednumeric"
                              style="width: 80%"
                              required
                              >
                            </kendo-textbox>
                            <a
                              class="cursor-pointer"
                              (click)="_generatePOBarcodeClick(rowIndex)"
                              ><img
                              class="searchIcon"
                              [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'"
                            /></a>
                          </ng-template>
                        </kendo-grid-column> -->
                        <kendo-grid-column field="PONumber" title="PO#" [width]="350">
                          <ng-template style="width: 5rem !important" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            <asap-barcode-generation class="transaction-grid-barcode-generator" [placeholder]="'PO#'"
                              [entityName]="'purchaseOrders'" [disabled]="dataItem.isDisabledPo" [value]="dataItem.PONumber"
                              (valueChange)="_poNumberValueChange($event, rowIndex)"
                              [icon]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                            </asap-barcode-generation>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="stockItemNumber" title="Stock Item#">
                        </kendo-grid-column>
                        <kendo-grid-column field="stockDescription" title="Stock Description">
                        </kendo-grid-column>
                        <kendo-grid-column field="posobackquantity" title="Backorder Quantity">
                        </kendo-grid-column>
                        <kendo-grid-column field="receiveUOM" title="Receive UOM">
                        </kendo-grid-column>
                        <kendo-grid-column field="quantityToOrder" title="Quantity To Order">
                          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            <kendo-numerictextbox style="width: 100%" class="k-textbox writebox smallNumeric requirednumeric"
                              [min]="0" [value]="dataItem.quantityToOrder" [autoCorrect]="true" format="{{ quantityFormat }}"
                              (valueChange)="_orderedQuantityValueChanged($event, rowIndex)">
                              <!-- (valueChange)="_orderedQuantityValueChanged($event)" -->
                            </kendo-numerictextbox>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="vendor" title="Vendor">
                          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            <kendo-combobox style="width: 100%" [data]="_vendorsFiltered" [filterable]="true"
                              [(ngModel)]="dataItem.vendor" name="vendor_{{ rowIndex }}"
                              (valueChange)="_handleVendorsChange($event, rowIndex)" (filterChange)="_handleVendorsFilter($event)"
                              [disabled]="dataItem.isDisabledVendor" [placeholder]="'Choose a Vendor'" [textField]="'code'"
                              [valueField]="'id'" [suggest]="true" class="bordered" required>
                            </kendo-combobox>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column title="Action" [width]="150">
                          <ng-template kendoGridCellTemplate>
                            <div kendoGridRemoveCommand class="asap-grid-remove">
                              <div class="asap-grid-remove-icon">
                                <img src="/assets/menu/enterprise/remove-icon.svg" />
                              </div>
                              <div class="asap-grid-remove-text">Delete</div>
                            </div>
                          </ng-template>
                        </kendo-grid-command-column>
                      </kendo-grid>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </kendo-window>
        }

        @if (_editFormActive) {
          <kendo-window
            title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
            (close)="_closeCustomFields()" class="customFieldsWindow">
            <asap-custom-fields [accounts]="_selectedAccountIds" [tabGroup]="_selectedTabId" [labelId]="_selectedLabelId"
              [labelObjectCode]="_selectedLabelObjectCode" [formName]="'stock'" page="salesOrders"
              [isCustomfieldsForm]="_isCustomfieldsFormValue" [isCustomtabsForm]="_isAddTabFormValue"
              [isRenameForm]="_isRenameFormValue" [language]="_language" [isRenameCustomForm]="_isRenameCustomFormValue"
              [isRenameLabel]="_isRenameLabel" [isMandatory]="_isMandatory" (closePopup)="ClosePopup($event)"
              [permissionScope]="_permissionScope" [hasRequired]="_hasRequired" [onlyRequired]="_onlyRequired"
              [isTransaction]="_isTransaction">
            </asap-custom-fields>
          </kendo-window>
        }

        @if (_orderingTabsForm) {
          <kendo-window title="Tab Reordering" (keydown.enter)="$event.preventDefault()"
            (close)="_closeOrderingTabsForm()">
            <div class="row no_row_margin margin-top-30">
              @if (false) {
                <div class="col-12 margin-top-10">
                  <div class="form-group">
                    <label for="itemType" class="control-label">Tab 1</label>
                    <kendo-combobox [data]="_dataTabsSelected" [suggest]="true" [textField]="'name'" [valueField]="'name'"
                      placeholder="Accounts/Sites" class="newFormControlWidth disabled">
                    </kendo-combobox>
                  </div>
                </div>
              }
              @for (item of _dataTabs ; track item; let i = $index) {
                <div class="col-12 margin-top-10">
                  <div class="form-group">
                    <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                    <kendo-combobox [data]="_dataTabsSelected" [suggest]="true" [textField]="'name'" [valueField]="'name'"
                      [placeholder]="item.name" required class="bordered newFormControlWidth"
                      (valueChange)="_comboValueChange($event,i)">
                    </kendo-combobox>
                  </div>
                </div>
              }
            </div>
            <div class="row no_row_margin">
              <div class="col-12">
                <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>save & Close</span>
                </button>
              </div>
            </div>
          </kendo-window>
        }

        @if (_showDocumentsGrid) {
          <kendo-window title="{{'Add Document(s) to Sales Order'}}" (close)="_closeDocumentsWindow()"
            class="addFromLibrary">
            <div class="greytabtop">
              <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedDocumentsHandler($event)">
                Select & Return
              </button>
            </div>
            <asap-grid-layout [selectable]="true" [pagingEnabled]="true" [selectByField]="'id'"
              [selectByFieldTitle]="'Select Document'" [enableSiteSelection]="false" [filteringEnable]="true"
              [selectedKeys]="_selectedDocumentsKeys" [resolver]="_getAccountDocuments" [orderEnable]="true"
              [sortingEnabled]="true" (onRowSelectionChanges)="_onDocumentRowSelectionChanges($event)"
              (onRowObjectSelectionChanges)="_onDocumentbjectRowSelectionChanges($event)">
              <ng-template pageListColumn name="Name" field="name" let-item>
                {{item.name}}
              </ng-template>
              <ng-template pageListColumn name="Description" field="description" let-item>
                {{item.description}}
              </ng-template>
              <ng-template pageListColumn name="Type" field="type" let-item>
                {{item.type}}
              </ng-template>
              <ng-template pageListColumn name="Stream" let-item>
                <img src="{{ item.stream }}" alt="{{ item.name }}" width="50" />
              </ng-template>
            </asap-grid-layout>
          </kendo-window>
        }

        @if (_isEditForms) {
          <asap-edit-forms (close)="_onCloseEditForms($event)" (saved)="_closeCustomFields()" [page]="_page"
            [permissionScope]="_permissionScope">
          </asap-edit-forms>
        }
        @if (_showStockItemFileNotes) {
          <kendo-window title="Stock Notes" (close)="_closeStockItemNotesWindow()"
            class="addFromLibrary">
            @if (!_currentUser.isEnterprise) {
              <div class="borderedNotesContainer">
                <note #note [_pageState]="3" [_model]="_stockItemNotesModel" [_page]="'stockItems'">
                </note>
              </div>
            }
          </kendo-window>
        }
        @if (_showCustomerFileNotes) {
          <kendo-window title="Customer Notes" (close)="_closeCustomerNotesWindow()"
            class="addFromLibrary">
            @if (!_currentUser.isEnterprise) {
              <div class="borderedNotesContainer">
                <note #note [_pageState]="3" [_model]="_customerNotesModel" [_page]="'customers'">
                </note>
              </div>
            }
          </kendo-window>
        }